import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  for: "size",
  class: "p-the-c01-form__item__label"
}
const _hoisted_3 = { class: "p-the-c01-form__item__select" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "p-the-c01-form__item" }
const _hoisted_6 = { class: "p-the-c01-form__item__select" }
const _hoisted_7 = { class: "p-the-c01-form__item" }
const _hoisted_8 = {
  key: 2,
  class: "p-the-c01-form__extras"
}
const _hoisted_9 = { class: "p-the-c01-form__button_group" }
const _hoisted_10 = {
  key: 0,
  class: "p-the-c01-form__button_group__item"
}
const _hoisted_11 = { class: "p-the-c01-form__button_group__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_FormCount = _resolveComponent("FormCount")!
  const _component_C01ItemFormExtraProp = _resolveComponent("C01ItemFormExtraProp")!
  const _component_ValidationErrorText = _resolveComponent("ValidationErrorText")!
  const _component_TheC01ItemFormNotePanelShortage = _resolveComponent("TheC01ItemFormNotePanelShortage")!
  const _component_TheC01ItemFormNotePanelGiftCard = _resolveComponent("TheC01ItemFormNotePanelGiftCard")!
  const _component_TheC01ItemFormNotePanelDrink = _resolveComponent("TheC01ItemFormNotePanelDrink")!
  const _component_TheC01ItemFormOnlyTypeInCart = _resolveComponent("TheC01ItemFormOnlyTypeInCart")!
  const _component_IconCart = _resolveComponent("IconCart")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_IconFavorite40px = _resolveComponent("IconFavorite40px")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    "validation-schema": _ctx.schema,
    onSubmit: _ctx.submit,
    ref: "form",
    action: "/cart-details/",
    method: "post",
    name: "form_item",
    class: "p-the-c01-form"
  }, {
    default: _withCtx(({ errors }) => [
      (_ctx.options.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionTypes, (option, key) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_ctx.isHiddenItem == false)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: "p-the-c01-form__item"
                    }, [
                      _createElementVNode("label", _hoisted_2, _toDisplayString(option.name), 1),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_Field, {
                          name: `option_${key}`,
                          as: "select",
                          modelValue: _ctx.flag[key],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.flag[key]) = $event),
                          rules: { required: true }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_InputSelect, {
                              id: 'size' + key,
                              name: 'size' + key,
                              color: "#616161",
                              error: errors[`option_${key}`],
                              options: _ctx.getOptions(option.id),
                              onSelected: ($event: any) => (_ctx.onChangeSelect($event, option.id, option.name))
                            }, null, 8, ["id", "name", "error", "options", "onSelected"])
                          ]),
                          _: 2
                        }, 1032, ["name", "modelValue", "onUpdate:modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256))
          ]))
        : _createCommentVNode("", true),
      (_ctx.clientList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("label", {
                style: {"font-size":"10px"},
                for: "size",
                class: "p-the-c01-form__item__label"
              }, " お客様番号 ", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Field, {
                  name: "clientListOption",
                  as: "select",
                  modelValue: _ctx.clientListOption,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.clientListOption) = $event)),
                  rules: { required: true }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputSelect, {
                      name: 'clientOption',
                      color: "#616161",
                      error: errors.clientListOption,
                      options: _ctx.clientList
                    }, null, 8, ["error", "options"])
                  ]),
                  _: 2
                }, 1032, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _cache[3] || (_cache[3] = _createElementVNode("label", {
          for: "count",
          class: "p-the-c01-form__item__label"
        }, "個数", -1)),
        _createVNode(_component_FormCount, {
          id: "count",
          modelValue: _ctx.count,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.count) = $event)),
          stock: _ctx.stock,
          name: "count",
          min: 1,
          max: _ctx.maxStock
        }, null, 8, ["modelValue", "stock", "max"])
      ]),
      (_ctx.haveExtraProps)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.sortedExtraOptions)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.sortedExtraOptions, (option, key) => {
                  return (_openBlock(), _createElementBlock("div", { key: key }, [
                    _createVNode(_component_Field, {
                      name: `extra_${key}`,
                      rules: {
                required: true,
                regex: new RegExp(option.regex),
                min: option.min_length,
                max: option.max_length
              },
                      modelValue: option.value,
                      "onUpdate:modelValue": ($event: any) => ((option.value) = $event)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_C01ItemFormExtraProp, {
                          id: option.sku,
                          label: option.name,
                          placeholder: option.name,
                          maxlength: option.max_length,
                          minlength: option.min_length,
                          error: errors[`extra_${key}`],
                          class: "p-the-c01-form__extras__item"
                        }, null, 8, ["id", "label", "placeholder", "maxlength", "minlength", "error"]),
                        _withDirectives(_createVNode(_component_ValidationErrorText, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(errors[`extra_${key}`]), 1)
                          ]),
                          _: 2
                        }, 1536), [
                          [_vShow, errors[`extra_${key}`]]
                        ])
                      ]),
                      _: 2
                    }, 1032, ["name", "rules", "modelValue", "onUpdate:modelValue"])
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      ((!_ctx.userPointsAreGreaterThanProductPoint && _ctx.hasStock) || !_ctx.compareSaleEndDate)
        ? (_openBlock(), _createBlock(_component_TheC01ItemFormNotePanelShortage, {
            key: 3,
            possession: _ctx.possession,
            "credit-card-enabled": _ctx.creditCardEnabled,
            "cart-empty": _ctx.cartEmpty,
            count: _ctx.count,
            type: _ctx.type,
            "sale-end-date": _ctx.saleEndDate,
            class: "p-the-c01-form__note"
          }, null, 8, ["possession", "credit-card-enabled", "cart-empty", "count", "type", "sale-end-date"]))
        : _createCommentVNode("", true),
      (!_ctx.isOnlyTypeInCart)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            (_ctx.userPointsAreGreaterThanProductPoint && !_ctx.cartEmpty && _ctx.hasStock)
              ? (_openBlock(), _createBlock(_component_TheC01ItemFormNotePanelGiftCard, {
                  key: 0,
                  "is-gift-card-and-normal-item-in-cart": _ctx.isGiftCardAndNormalItemInCart,
                  "is-normal-item-and-gift-card-in-cart": _ctx.isNormalItemAndGiftCardInCart,
                  "is-web-coupon-and-gift-item-in-cart": _ctx.isWebCouponAndGiftItemInCart,
                  "is-gift-card-and-web-coupon-item-in-cart": _ctx.isGiftCardAndWebCouponItemInCart,
                  "is-web-coupon-and-normal-item-in-cart": _ctx.isWebCouponAndNormalItemInCart,
                  "is-benepo-exchange-and-somethings-in-cart": _ctx.isBenepoExchangeAndSomethingsInCart,
                  class: "p-the-c01-form__note"
                }, null, 8, ["is-gift-card-and-normal-item-in-cart", "is-normal-item-and-gift-card-in-cart", "is-web-coupon-and-gift-item-in-cart", "is-gift-card-and-web-coupon-item-in-cart", "is-web-coupon-and-normal-item-in-cart", "is-benepo-exchange-and-somethings-in-cart"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.ageAlert)
        ? (_openBlock(), _createBlock(_component_TheC01ItemFormNotePanelDrink, {
            key: 5,
            value: _ctx.isAdult,
            class: "p-the-c01-form__note",
            onChecked: _ctx.onCheckAdult
          }, null, 8, ["value", "onChecked"]))
        : _createCommentVNode("", true),
      (_ctx.isOnlyTypeInCart)
        ? (_openBlock(), _createBlock(_component_TheC01ItemFormOnlyTypeInCart, {
            key: 6,
            class: "p-the-c01-form__note"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.hasStock)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_ButtonMain, {
                type: "submit",
                disabled: _ctx.disabled || !_ctx.compareSaleEndDate || _ctx.isHiddenItem
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconCart, {
                    "icon-size": 40,
                    "icon-color": "#ffffff"
                  })
                ]),
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createTextVNode(" カートに追加 ", -1))
                ]),
                _: 1,
                __: [4]
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_ButtonMain, {
            type: "button",
            kind: "cancel",
            disabled: _ctx.isDrinkStop || !_ctx.isSkuSelected || !_ctx.compareSaleEndDate,
            onClickButton: _ctx.changeFavorite
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_IconBase, {
                width: 40,
                height: 40,
                "view-box": "0 0 40 40"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconFavorite40px, { "is-favorite": _ctx.isFavorite }, null, 8, ["is-favorite"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(_ctx.favoriteLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClickButton"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema", "onSubmit"]))
}